import { getEstimate, putEstimate } from '../../../../api/eastCoastDataApi/setting/PassengerEstimateSettingApi'
import CONST from '../../../../utils/const'
import Utils from '../../../../utils/utils'

const state = {
  allEstimateData : [],
  elkCarEnumData: []
}

const getters = {
  getInternalEstimateWeight: state => {

    if (Utils.isEmptyObject(state.allEstimateData)) {
      return CONST.ELK_CAR_TYPE_ENUM
    }

    let internalEstimateList = []
    for(let i = 0 ; i < state.allEstimateData.length ; i++) {
      if(state.allEstimateData[i].isInternal === 'true') {
        internalEstimateList = state.allEstimateData[i][CONST.ESTIMATE_KEY]
      }
    }

    const internalWeight = JSON.parse(JSON.stringify(CONST.ELK_CAR_TYPE_ENUM))
    for (let i = 0; i < internalWeight.length; i++) {
      const target = internalEstimateList.filter(item => item.passengerType === internalWeight[i].estimateCarType)
      
      for(let j = 0 ; j < target.length ; j++) {
        switch(target[j][CONST.DATE_TYPE_KEY]) {
          case 'holiday':
            internalWeight[i].holidayWeight = target[j][CONST.AVERAGE_NUM_KEY]
            break

          case 'ordinaryDay':
            internalWeight[i].weight = target[j][CONST.AVERAGE_NUM_KEY]
            break  
        }
      }

    }

    return internalWeight
  },

  getExternalEstimateWeight: state => {
    if (Utils.isEmptyObject(state.allEstimateData)) {
      return CONST.ELK_CAR_TYPE_ENUM
    }

    let externalEstimateList = []
    for(let i = 0 ; i < state.allEstimateData.length ; i++) {
      if(state.allEstimateData[i].isInternal === 'false') {
        externalEstimateList = state.allEstimateData[i][CONST.ESTIMATE_KEY]
      }
    }


    const externalWeight = JSON.parse(JSON.stringify(CONST.ELK_CAR_TYPE_ENUM))
    for (let i = 0; i < externalWeight.length; i++) {
      const target = externalEstimateList.filter(item => item.passengerType === externalWeight[i].estimateCarType)
      
      for(let j = 0 ; j < target.length ; j++) {
        switch(target[j][CONST.DATE_TYPE_KEY]) {
          case 'holiday':
            externalWeight[i].holidayWeight = target[j][CONST.AVERAGE_NUM_KEY]
            break

          case 'ordinaryDay':
            externalWeight[i].weight = target[j][CONST.AVERAGE_NUM_KEY]
            break  
        }
      }
    }

    return externalWeight
  }
}

const actions = {
  async getEstimate({ commit }) {
    const result = await getEstimate()
    if(result.success) {
      commit('estimateData', result.data)
    }
  },

  async putEstimate({ commit }, estimate) {
    const result = await putEstimate(estimate)

    if(result.success) {
      commit('updateEstimate', { data: estimate, mode: 'put' })
    }

    return result
  },
}

const mutations = {
  estimateData(state, data) {
    if(Utils.isEmptyObject(data)) {
      return
    }

    state.allEstimateData = data
  },

  updateEstimate(state, { data, mode }) {
    switch (mode) {
      case 'post':
        state.allEstimateData.push(data)
        break
      
      case 'put':
        let targetIndex  = state.allEstimateData.findIndex(d => d.id === data.id)
        if (targetIndex !== -1) {
          state.allEstimateData[targetIndex] = data;
        } 
        break
  
      case 'delete' :
        state.allEstimateData = state.allEstimateData.filter(d => d.id !== data)
        break    
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
